import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';


// More varied data with ups and downs to create dynamic curves
const data = [
  { date: '07 Jul', bids: 5 },
  { date: '08 Jul', bids: 9 },
  { date: '09 Jul', bids: 6 },
  { date: '12 Jul', bids: 13 },
  { date: '05 Jul', bids: 9 },
  { date: '04 Jul', bids: 19 },
  { date: '02 Jul', bids: 6 },
  { date: '30 Jun', bids: 15 },
  { date: '29 Jun', bids: 7 },
];


// Simple black text tooltip
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="text-lg font-semibold text-gray-900">
        {payload[0].value} bids
      </div>
    );
  }
  return null;
};


const BiddingActivityChart = () => {
  return (
    <div>
      {/* Heading outside the card */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2.5">Bidding Activity</h3>
      
      {/* Chart card with dotted grid background */}
      <div className="bg-white rounded-xl pr-8 pt-6 pb-4 shadow-sm border-[1px] border-light-blue">
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart data={data} margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorBids" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.35}/>
                <stop offset="95%" stopColor="#dbeafe" stopOpacity={0.1}/>
              </linearGradient>
            </defs>
            
            {/* Vertical Dotted Grid Background */}
            <CartesianGrid 
              strokeDasharray="1 4" 
              stroke="#e5e7eb" 
              horizontal={true}
              vertical={true}
            />
            
            {/* X-Axis with tick marks */}
            <XAxis 
              dataKey="date" 
              tick={{ fontSize: 13, fill: '#6b7280' }}
              axisLine={false}
              tickLine={{ stroke: '#6b7280', strokeWidth: 1 }}
              tickSize={5}
              interval={0}
              angle={0}
            />
            
            {/* Y-Axis with tick marks */}
            <YAxis 
              tick={{ fontSize: 13, fill: '#6b7280' }}
              axisLine={false}
              tickLine={{ stroke: '#6b7280', strokeWidth: 1 }}
              tickSize={5}
              domain={[0, 20]}
              ticks={[0, 5, 10, 15, 20]}
            />
            
            {/* Tooltip with simple black text */}
            <Tooltip content={<CustomTooltip />} cursor={false} />
            
            {/* Area with smooth natural curve - dots only on hover */}
            <Area 
              type="natural" 
              dataKey="bids" 
              stroke="#2563eb" 
              strokeWidth={3}
              fill="url(#colorBids)" 
              dot={false}
              activeDot={{ 
                r: 8,
                fill: '#2563eb', 
                stroke: '#fff', 
                strokeWidth: 3
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};


export default BiddingActivityChart;
